// src/poker/context/PokerContext.js
import React, { createContext, useContext, useState } from 'react';

const PokerContext = createContext(null);

export function PokerProvider({ children }) {
  const [lobbyTables, setLobbyTables] = useState([]); // список всех столов
  const [tableState, setTableState]   = useState(null); // состояние текущего стола

  return (
    <PokerContext.Provider value={{ lobbyTables, setLobbyTables, tableState, setTableState }}>
      {children}
    </PokerContext.Provider>
  );
}

export const usePoker = () => useContext(PokerContext);
